module.exports = __webpack_public_path__ + "static/myimage-ec092689bb70aff8e84fca18a1e511ff.jpg";